import React from 'react'
import { FormProvider, UseFormReturn } from 'react-hook-form'
import { FormFieldType } from '@App/forms/v2/common/form-field'
import Button from '@Components/Buttons/Button'
import InnerForm from '@App/kit/fields/v2/InnerForm'

interface FormProps {
    formFields: FormFieldType<unknown>
    onSubmit: (data: any) => void
    icon?: string
    submitButtonLabel: string
    methods: UseFormReturn<any>
    disableSubmit?: boolean
}

const Form = (props: FormProps) => {
    const { onSubmit, submitButtonLabel, icon, formFields, methods, disableSubmit } = props

    const { handleSubmit } = methods
    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <>
                    <InnerForm formFields={formFields} />
                    <Button mainColor type="primary" icon={icon} submitType="submit" disabled={!!disableSubmit}>
                        {submitButtonLabel}
                    </Button>
                </>
            </form>
        </FormProvider>
    )
}

export default Form
